import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathGreaterThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMathGreaterThan"><Path fillRule="evenodd" clipRule="evenodd" d="M5.46154 5.69238L20.6 12.0001L5.46154 18.3078L4.69231 16.4616L15.4 12.0001L4.69231 7.53854L5.46154 5.69238Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathGreaterThan;
